export default {
  responsive: {
    xs: 24,
    sm: 18,
    md: 12,
    lg: 24,
    xl: 24,
    xxl: 18,
  },
};
